// Animation for loading the collections in the 'collections' page
// similar to the animation of products
var CollectionListGrid = class extends CustomHTMLElement {
    async connectedCallback() {
      // console.log("CollectionListGrid connectedCallback called"); // Debugging log
      this.items = Array.from(this.querySelectorAll(".list-collections-grid__item-wrapper[stagger-apparition]")); // Select items with stagger-apparition
      if (!this.hidden && this.staggerApparition) {
        this._staggerCollectionsApparition();
      }
    }
    get staggerApparition() {
        return this.hasAttribute("stagger-apparition");
      }
    get apparitionAnimation() {
        return this._animation = this._animation || new CustomAnimation(new ParallelEffect(this.items.map((item, index) => {
            return new CustomKeyframeEffect(item, {
                opacity: [0, 1],
                transform: [`translateY(${MediaFeatures.prefersReducedMotion() ? 0 : window.innerWidth < 1e3 ? 35 : 60}px)`, "translateY(0)"]
                }, {
                duration: 600,
                delay: MediaFeatures.prefersReducedMotion() ? 0 : 100 * index - Math.min(3 * index * index, 100 * index),
                easing: "ease"
            });
        })));
    }
    async _staggerCollectionsApparition() {
        this.items.forEach((item) => item.style.opacity = 0);
        await this.untilVisible({ threshold: this.clientHeight > 0 ? Math.min(50 / this.clientHeight, 1) : 0 });
        this.apparitionAnimation.play();
    }
};
window.customElements.define("collection-list-grid", CollectionListGrid);


/*
- Added a <script> tag with a JavaScript function adjustFontSize().
- This function selects all elements with the class .list-collections__item-title_.
- For each title, it starts with a font size of 20px and gradually reduces it if the content overflows.
- The font size reduction stops at 10px to ensure readability.
- The function runs on both page load and window resize to ensure proper sizing in all scenarios.
*/
function adjustFontSize() {
    const titles = document.querySelectorAll('.list-collections-grid__item-title, .list-collections-grid__item-title_truncate');
    const pageWidth = window.innerWidth;
    
    let initialFontSize;
    if (pageWidth < 741) {
      initialFontSize = 20; // Slightly smaller initial size for mobile
    } else if (pageWidth < 1000) {
      initialFontSize = 20;
    } else {
      initialFontSize = 20;
    }

    titles.forEach(title => {
      let fontSize = initialFontSize;
      title.style.fontSize = `${fontSize}px`;

      // For truncated titles, check offsetWidth instead of scrollHeight
      const isTruncated = title.classList.contains('list-collections-grid__item-title_truncate');
      const checkOverflow = isTruncated ? 
        () => title.offsetWidth < title.scrollWidth :
        () => title.scrollHeight > title.offsetHeight;

      while (checkOverflow() && fontSize > 10) {
        fontSize--;
        title.style.fontSize = `${fontSize}px`;
      }
    });
}

// Run on page load
document.addEventListener('DOMContentLoaded', adjustFontSize);

// Run on window resize
let resizeTimer;
window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(adjustFontSize, 250); // Debounce resize events
});
